var exports = {
  "kL": "StatusSlate.module__container___akZXaW",
  "Nb": "StatusSlate.module__fullHeight___akZXaW",
  "Kk": "StatusSlate.module__icon___akZXaW",
  "DD": "StatusSlate.module__title___akZXaW",
  "h_": "StatusSlate.module__description___akZXaW",
  "o1": "StatusSlate.module__actions___akZXaW",
};

module.exports = exports;
